export const asciiBlockFills = {
	sparse: "░",
	medium: "▒",
	dense: "▓",
	full: "█",
	fullTopHalf: "▀",
	fullRightHalf: "▐",
	fullBottomHalf: "▄",
	fullLeftHalf: "▌",
};

export const nodeColorPool = [
	"oklch(66.01% 0.102 256.84)",
	"oklch(83.85% 0.045 255.65)",
	"oklch(85.27% 0.082 133.76)",
	"oklch(79.35% 0.114 134.19)",
	"oklch(73.53% 0.144 134.81)",
	"oklch(85.41% 0.159 90.99)",
	"oklch(88.58% 0.134 92.8)",
	"oklch(92.02% 0.096 93.48)",
	"oklch(85.76% 0.083 66.34)",
	"oklch(79.72% 0.119 64.27)",
	"oklch(74.11% 0.15 60.68)",
	"oklch(61.11% 0.209 26.72)",
	"oklch(67.74% 0.166 23.81)",
	"oklch(76.29% 0.114 22.04)",
	"oklch(76.22% 0.076 328.53)",
	"oklch(67.77% 0.104 328.99)",
	"oklch(59.43% 0.132 329.56)",
	"oklch(67.97% 0.137 0.41)",
	"oklch(76.71% 0.095 357.96)",
	"oklch(85.97% 0.054 355.85)",
	"oklch(53.41% 0.083 355.37)",
	"oklch(45.6% 0.133 284.59)",
	"oklch(47.42% 0.139 24.1)",
	"oklch(55.93% 0.105 65.35)",
	"oklch(61.06% 0.162 38.94)",
	"oklch(83.08% 0.09 43.01)",
	"oklch(79.09% 0.046 153.13)",
	"oklch(60.83% 0.035 150.78)",
	"oklch(58.71% 0.081 133.54)",
	"oklch(50.08% 0.077 251.97)",
	"oklch(52.49% 0.106 234.7)",
	"oklch(82.4% 0.065 219.06)",
	// oxlint-disable-next-line no-array-sort
].sort(() => Math.floor(Math.random() * 3) - 1);
